import * as actions from '../actions/';
import * as pillarActions from '../../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../../extracts.module.config';
import { IExtractState } from '../state/IExtractState';
import { ExtractListModel } from "../../models/ExtractListModel";

export const initialState: IExtractState = {
  extractCategories: [],
  extractList: [],
  extractListTotalCount: 0,
  extractListLoading: false,
  extractCategoryLoading: true,
  extractCategorySelected: null,
  extractListCurrentPage: 0,
  extractListSelected: null,
  extractWorkspaceList: [],
  extractWorkspaceListTotalCount: 0,
  extractWorkspaceListLoading: false
}

export function extractsStateReducer(state = initialState, action: actions.Actions): IExtractState {
  switch (action.type) {
    case actions.GET_EXTRACT_CATEGORY_QUERY_SUCCESS:
      return {
        ...state,
        extractCategoryLoading: false,
        extractCategories: (action as actions.GetExtractCategoryQuerySuccessAction).payload.items
      };
    case actions.GET_EXTRACT_LIST_SUCCESS_ACTION:
      return {
        ...state,
        extractListLoading: false,
        extractList: (action as actions.GetExtractListSuccessAction).payload.items
      };
    case pillarActions.querySuccessType(ModuleConfiguration.moduleName, ExtractListModel):
      return {
        ...state,
        extractListLoading: false,
        extractList: (action as actions.GetExtractListSuccessAction).payload.items,
        extractListTotalCount: (action as pillarActions.QuerySuccessAction<ExtractListModel>).payload.totalCount,
      };
    case actions.GET_EXTRACT_LIST_ACTION:
      return {
        ...state,
        extractListLoading: true,
      };
    case actions.SET_SELECTED_EXTRACT_MODEL:
      return {
        ...state,
        extractCategorySelected: (action as actions.SetSelectedExtractModelAction).payload.model
      };
    case actions.SET_SELECTED_EXTRACT_LIST_MODEL:
      return {
        ...state,
        extractListSelected: (action as actions.SetSelectedExtractListModelAction).payload.model
      };
    case actions.GET_SELECTED_EXTRACT_ACTION:
      return {
        ...state,
        extractWorkspaceListLoading: true,
      };
    case actions.GET_SELECTED_EXTRACT_SUCCESS_ACTION:
      return {
        ...state,
        extractWorkspaceListLoading: false,
        extractWorkspaceList: (action as actions.GetSelectedExtractSuccessAction).payload.items
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/reducers/extracts-reducer.ts